import { MILLISECONDS_PER_MINUTE } from "./constants";

export default function minutesToMilliseconds(minutes: number) {
  return Math.floor(minutes * MILLISECONDS_PER_MINUTE);
}
